import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/playmaxx-logo-new.svg")